// extracted by mini-css-extract-plugin
module.exports =  {"delay":"Mx2mxSPu5_R8yX2VYGHq","delayElement":"u8_b37cvMbNAuF5LjVrf"};